/* eslint-disable no-unused-vars */
import React from "react";
import { useContext } from "react";
import { Navigate } from "react-router-dom";

import LogoHeader from "../common/LogoHeader";

import LoginAdmin from "../AdminLogin";
import useUserStore from "../../stores/useUserStores";

const AuthAdminLogin = () => {
  const { islogin } = useUserStore();
  return (
    <>
      {!islogin ? (
        <>
          <LogoHeader />
          <LoginAdmin />
        </>
      ) : (
        <Navigate replace to="/admin-dashboard" />
      )}
    </>
  );
};

export default AuthAdminLogin;
